module.exports = __webpack_public_path__ + "sit/20260418112858/img/service.edbff227.png";